import { register, find } from '../../../Javascript/Utils.js'
import Swiper from 'swiper'
import { Navigation, Pagination, Autoplay } from 'swiper/modules'
Swiper.use([Navigation, Pagination, Autoplay])

const CoverSlider = el => {
  const sliderContainer = find('.swiper-container', el)
  const componentPrefix = 'mCoverSlider-'
  const myNext = find(`.${componentPrefix}next`, el)
  const myPrev = find(`.${componentPrefix}prev`, el)
  const autoPlay = document.querySelector('html').getAttribute('data-reduced-motion') ? false : !!el.dataset.autoplay
  const loop = !!el.dataset.loop
  function makeSwiper () {
    return new Swiper(sliderContainer, {
      slidesPerView: 2.5,
      spaceBetween: 16,
      autoplay: autoPlay,
      // autoHeight: true, => causes rendering issues in firefox 77.0.1 / wrong height
      loop,
      slidesOffsetBefore: 0,
      navigation: {
        nextEl: myNext,
        prevEl: myPrev
      },
      breakpoints: {
        1200: {
          slidesPerView: 6.75,
          spaceBetween: 32
        },
        1012: {
          slidesPerView: 5.75,
          spaceBetween: 32
        },
        920: {
          slidesPerView: 4.75,
          spaceBetween: 32
        },
        720: {
          slidesPerView: 4.5,
          spaceBetween: 32
        },
        520: {
          slidesPerView: 2.75,
          spaceBetween: 16
        },
        420: {
          slidesPerView: 2.75,
          spaceBetween: 16
        },
        419: {
          slidesPerView: 2.5,
          spaceBetween: 16
        }
      }
    })
  }
  makeSwiper()
}
register('CoverSlider', CoverSlider)
